module.exports = __webpack_public_path__ + "static/media/card-white.6d13cc75.svg";